import React, { useEffect, useState } from "react";
import axios from 'axios';
import { useSelector } from "react-redux";
import { Link, useParams } from 'react-router-dom';
import EditImageProduct from "./EditImageProduct";



const EditProduct = ({ isAuthenticatedAd }) => {

    const [active, setActive] = useState('');

    const [disableSave, setDisableSave] = useState(true);
    const [showStatus, setShowStatus] = useState(false);

    const { apiUrl } = useSelector(state => state.api);

    const { userId, userName } = useSelector(state => state.user);

    const { productId } = useParams();

    const [editInfoProduct, setEditInfoProduct] = useState({
        product_name: "",
        product_price: "",
        product_color: "",
        product_size: "",
        product_quantity: "",
        product_detail: "",
        product_img: ""
    });
    const [currentInfoProduct, setCurrentInfoProduct] = useState({
        product_name: "",
        product_price: "",
        product_color: "",
        product_size: "",
        product_quantity: "",
        product_detail: "",
        product_img: ""
    });




    const getProductdetails = async (productId) => {
        try {
            const response = await axios.get(`${apiUrl}/product/${productId}`)
            const detailProduct = response.data;
            // console.log(detailProduct);
            setEditInfoProduct(...detailProduct)
            setCurrentInfoProduct(...detailProduct)
        } catch (err) {
            console.error(err.message);
        }
    }
    useEffect(() => {
        if (productId) {
            getProductdetails(productId); // pass the id to getProductdetails function
        }
    }, [apiUrl, productId]); // add id as a dependency


    const changeSelection = (e) => {
        setActive(e.target.innerText);

    }
    // console.log(editInfoProduct.product_img);
    const editProduct = async (e) => {
        e.preventDefault()
        const data = { ...editInfoProduct };
        console.log(data);

        try {
            const isEqual = await Object.values(data).every((value, index) => value === Object.values(currentInfoProduct)[index]);
            if (!isEqual) {
                await axios.put(`${apiUrl}/dashboard/editproduct`, data, {
                    headers: { token: localStorage.getItem('token') }
                });

                setShowStatus("Information has changed!")
                // setTimeout(() => window.location.reload(), 1000)
            } else {
                setShowStatus("Inform ation does not change!");
                setTimeout(() => setShowStatus(true), 3000)
            }
        } catch (err) {
            console.error(err.message);

        }
    }

    const handleChangeInfoUser = (event) => {
        setEditInfoProduct({
            ...editInfoProduct,
            [event.target.name]: event.target.value,
        });
    };

    return (
        <>
            {(isAuthenticatedAd && isAuthenticatedAd !== "user") ? (
                <div className="container-myaccount justify-content-center align-items-center" >
                    <h2 className="text-center">Welcome to Dashboard {userName}!!!</h2>
                    <div className="row">

                        <div className="col-md-2 text-left mt-2">
                            <div className="item-list ">
                                <h4>Edit Product</h4>
                                <div className="bg-light ">
                                    <Link to="/dashboard/productsmanagement" params={active} className="text-decoration-none text-reset">
                                        <div className={active === 'Product' ? 'item active' : 'item'} onClick={changeSelection}>Go Back Management</div>
                                    </Link>
                                </div>

                                {/* <div className="bg-light">
                                    <Link to="/myaccount/password" className="text-decoration-none text-reset">
                                        <div className={active === 'Change password' ? 'item active' : 'item'} onClick={changeSelection}>Change password</div>
                                    </Link>
                                </div>
                                <div className="bg-light">
                                    <Link to="/myaccount/placeorders" className="text-decoration-none text-reset">
                                        <div className={active === 'Orders' ? 'item active' : 'item'}
                                            onClick={(e) => { changeSelection(e); }}
                                        >Orders</div>
                                    </Link>
                                </div> */}

                            </div>
                        </div>
                        {/* Profile */}
                        {/* Change password */}
                        {/* Orders*/}

                        <div className="col-md-10 bg-light p-2 mt-2">
                            <div className="row ">
                                <div class="col-md-6  text-center p-4 ">
                                    <EditImageProduct setDisableSave={setDisableSave} setEditInfoProduct={setEditInfoProduct}
                                        editInfoProduct={editInfoProduct}
                                    />

                                </div>
                                <div class="col-md-6 text-center border-start border-5">

                                    <form onSubmit={(e) => editProduct(e)}>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="name" class="form-label">Name:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="text" class="form-control" id="name" name="product_name"
                                                    value={editInfoProduct.product_name}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="name" class="form-label">Price:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="text" class="form-control" id="name" name="product_price"
                                                    value={editInfoProduct.product_price}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="text" class="form-label">Size:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="text" class="form-control" id="productsize" name="product_size"
                                                    value={editInfoProduct.product_size}
                                                    onChange={handleChangeInfoUser}

                                                />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="phone" class="form-label">Color:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input type="tel" class="form-control" id="productcolor" name="product_color"
                                                    value={editInfoProduct.product_color}
                                                    onChange={handleChangeInfoUser}
                                                />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="address" class="form-label">Quantity:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input class="form-control" id="productquantity" name="product_quantity" type="number"
                                                    value={editInfoProduct.product_quantity}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                ></input>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="address" class="form-label">Product details:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <textarea class="form-control" id="productdetail" name="product_detail"
                                                    value={editInfoProduct.product_detail}
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                >
                                                </textarea>
                                            </div>
                                        </div>

                                        {/* <div class="row">
                                            <div class="col-2 col-md-2 p-2 text-end">
                                                <label for="address" class="form-label">Image:</label>
                                            </div>
                                            <div class="col-10 col-md-9">
                                                <input class="form-control" id="inputState" name="product_img"
                                                    onChange={handleChangeInfoUser}
                                                    required
                                                    value={editInfoProduct.product_img}

                                                >
                                                </input>
                                            </div>
                                        </div> */}

                                        <div className="col-11 d-flex justify-content-end m-2">
                                            <button type="submit" className="btn btn-primary"
                                                disabled={disableSave}
                                            >Save</button>
                                        </div>
                                        {showStatus && <div class="uploadStatus">{showStatus}</div>}


                                    </form>
                                </div>

                            </div>
                        </div>


                    </div>
                </div >
            ) : (
                <div className="container-not">
                    <div className="d-flex justify-content-center align-items-center">
                        <img src="/frusti.jpg"
                            alt="Not-Authorized"
                            class="notAuthor" ></img>
                    </div>
                </div>
            )
            }
        </>
    )
}
export default EditProduct;